import { render, staticRenderFns } from "./IPQCSeleItemAdmin.vue?vue&type=template&id=390240f4&scoped=true"
import script from "./IPQCSeleItemAdmin.vue?vue&type=script&lang=js"
export * from "./IPQCSeleItemAdmin.vue?vue&type=script&lang=js"
import style0 from "./IPQCSeleItemAdmin.vue?vue&type=style&index=0&id=390240f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390240f4",
  null
  
)

export default component.exports